export const CableCarDemoCatalogId = 5455
